import React, { useState } from 'react';
import { Modal } from '@qwealth/qcore';
import { QLog, QTask } from '@qwealth/qdata';
import AddLog from 'components/common/Activities/Form/AddLog';
import AddEvent from 'components/common/Activities/Form/AddEvent';
import AddTask from 'components/common/Activities/Form/AddTask';
import { getTitle } from 'components/common/Activities/helper';
import { ACTIVITY_TYPE_EVENTS, ACTIVITY_TYPE_LOGS, ACTIVITY_TYPE_TASKS, ActivityType, ModalModeOptions } from 'data/models/Activity';
import { getActivityTags } from 'components/common/Activities/ComponentHelpers';

interface Props {
  onClose: () => void;
  show: boolean;
  type: ActivityType;
  initialEventValues?: any;
  initialTaskValues: Partial<QTask> | null;
  initialLogValues: Partial<QLog> | null;
  modalModeOption?: ModalModeOptions;
  setShowWorkflowModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EditActivityModal: React.FC<Props> = ({
  onClose,
  show,
  type,
  initialEventValues,
  initialTaskValues,
  initialLogValues,
  modalModeOption,
  setShowWorkflowModal,
}) => {
  const [isHidden, setIsHidden] = useState(false);

  return (
    <Modal
      title={getTitle({ type, initialEventValues, initialTaskValues, initialLogValues })}
      onClose={onClose}
      show={show}
      size="xl"
      titleProps={{
        textStyle: 'sectionTitle',
      }}
      tags={getActivityTags({ type, taskData: initialTaskValues })}
      hidden={isHidden}
    >
      <Modal.Body>
        {type === ACTIVITY_TYPE_EVENTS && <AddEvent event={initialEventValues} close={onClose} context="Household" />}
        {type === ACTIVITY_TYPE_TASKS && (
          <AddTask
            task={initialTaskValues}
            close={onClose}
            externalModeOption={modalModeOption}
            setIsTaskModalHidden={setIsHidden}
            setShowWorkflowModal={setShowWorkflowModal}
          />
        )}
        {type === ACTIVITY_TYPE_LOGS && <AddLog log={initialLogValues} close={onClose} />}
      </Modal.Body>
    </Modal>
  );
};
